<template>
  <b-form @submit.prevent="onSubmit">
    <b-card no-body class="radius-top-0">
      <template #header>
        <div class="d-flex justify-content-between align-items-center">
          <b>{{ contrapartida.nome }}</b>
          <div class="d-flex flex-row-reverse">
            <b-button type="submit" variant="exitos">Salvar</b-button>

            <router-link
              :to="$routeBack('contrapartidas_list')"
              class="btn btn-outline-muted mr-2"
              >Voltar para Listagem</router-link
            >
          </div>
        </div>
      </template>

      <b-tabs pills card vertical class="edit-menu-sidebar">
        <b-tab active>
          <template #title>
            <font-awesome-icon
              icon="exclamation-triangle"
              class="text-warning"
              v-show="!validations.dados_basicos"
            />
            Dados Básicos
          </template>
          <dados-contrapartida
            v-model="contrapartida"
            ref="dados_basicos"
          ></dados-contrapartida>
        </b-tab>
      </b-tabs>
    </b-card>
  </b-form>
</template>

<script>
import { mapActions, mapState } from "vuex";

import DadosContrapartida from "./Form/DadosContrapartida.vue";

export default {
  components: { DadosContrapartida },
  data: () => ({
    validations: {
      dados_basicos: true,
    },
  }),
  computed: {
    ...mapState("contrapartidas", ["contrapartida"]),
  },
  methods: {
    ...mapActions("contrapartidas", ["ActionSave"]),
    async onSubmit() {
      if (!this.isValid()) {
        this.$notifications.addNotification({
          message: "Os dados do formulário são inválidos",
          type: "danger",
        });
        return;
      }

      try {
        await this.ActionSave(this.contrapartida);
        this.$emit("saved", this.contrapartida.id);

        this.$notifications.addNotification({
          message: "Registro salvo com sucesso",
          type: "success",
        });
      } catch (error) {
        const message = "Erro ao salvar";
        this.$notifications.addNotification({
          message,
          icon: "exclamation-triangle",
          type: "danger",
        });
      }
    },
    isValid() {
      this.validations.dados_basicos = this.$refs.dados_basicos.isValid();
      return Object.values(this.validations).every(Boolean);
    },
  },
  async created() {},
};
</script>

<style></style>
